import Vue from "vue";
import Vuex from "vuex";
import persisted from "vuex-persistedstate";
import getters from "./getters";
import app from "./modules/app";
import settings from "./modules/settings";
import tagsView from "./modules/tagsView";
import productOrder from "./modules/productOrder";
import commonSavePage from "./modules/commonSavePage"; // 需要引入
import adminSelectFactory from "./modules/adminSelectFactory"; // 需要引入
import role from "./modules/role";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    persisted({
      paths: ["role"],
    }),
  ],
  modules: {
    app,
    settings,
    tagsView,
    productOrder,
    commonSavePage, // 需要声明
    adminSelectFactory, // 需要声明
    role,
  },
  getters,
});

export default store;
